import React from 'react';
import { useSelector } from 'react-redux';
import AdminBilling from './admin_billing';
import { getSelectedTeamAccountExpenseMealConfig } from '../../selectors/expenseMealsSelector';
import { EXPENSED_MEALS_PAYMENT_METHOD } from '../../types/expensed_meal';
export var AdminBillingContainer = function () {
    var _a;
    var selectedTeamAccountExpenseMealConfig = useSelector(getSelectedTeamAccountExpenseMealConfig);
    var paymentMethod = (_a = selectedTeamAccountExpenseMealConfig === null || selectedTeamAccountExpenseMealConfig === void 0 ? void 0 : selectedTeamAccountExpenseMealConfig.paymentMethod) !== null && _a !== void 0 ? _a : EXPENSED_MEALS_PAYMENT_METHOD.UNKNOWN;
    return React.createElement(AdminBilling, { paymentMethod: paymentMethod });
};
export default AdminBillingContainer;
